import {UploadedDocument } from '../models/documents';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.dev';
import { CreateDriver } from '../models/driver';
import { Observable } from 'rxjs';
import { DriverProfile, DriverSummary } from '../models/common-data-types';

@Injectable({
  providedIn: 'root',
})
export class DriversService {

  constructor(private http: HttpClient) { }

  private fileHeaders = new HttpHeaders({
    'Content-Type': 'multipart/form-data'
  });

  getDrivers(): Observable<DriverSummary[]> {
    return this.http.get<DriverSummary[]>(`/selfcare/drivers`);
  }

  addDriver(driver: CreateDriver) {
    return this.http.post<DriverProfile>(`/selfcare/drivers`, driver);
  }

  deleteDriver(driverId: string) {
    return this.http.delete(`/selfcare/drivers/${driverId}`);
  }

  getDriverDetails(driverId: string): Observable<DriverProfile>{
    return this.http.get<DriverProfile>(`/selfcare/drivers/${driverId}`);
  }

  uploadDocument(driverId: string, payload: FormData): Observable<DriverProfile> {
    return this.http.post<DriverProfile>(`/selfcare/drivers/${driverId}/documents/`, payload)
  }
}

